import { Injectable, NgZone } from '@angular/core';
import { act, Actions, createEffect, ofType } from '@ngrx/effects';
import { map, exhaustMap, catchError, tap, withLatestFrom, mergeMap, filter, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../app.state';
import { ErrorService } from '../../services/error.service';
import { failedTransaction, setLoadingSpinner } from '../actions/shared.actions';
import { ModalController, NavController, ToastController } from '@ionic/angular';
import { RouterNavigatedAction, ROUTER_NAVIGATION } from '@ngrx/router-store';
import { APIResponse } from 'src/app/models/api-response.model';
import { RideService } from 'src/app/services/ride.service';
import * as fromRideAction from '../actions/ride.action';
import { NavigationExtras } from '@angular/router';

@Injectable()
export class RideEffects {
    
  getRouteLines$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/bottom-tabs/ride')
      }),
      mergeMap(() => {
        return this.rideService.getRouteLines().pipe(
          map((response: APIResponse) => {           
            console.log('getRouteLines$', response);
            return fromRideAction.getRouteLinesSuccess({ data: response.details});
          })
        );
      })
    )
  
  });

  getBusStops$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromRideAction.getBusStops),
      exhaustMap((action) =>
        this.rideService.getBusStops(action.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            return fromRideAction.getBustStopsSuccess({ data: response });
          }),
          catchError((response) => {
            console.error('getBusStops$', response);
            this.store.dispatch(setLoadingSpinner({ status: false }));
            const error = {
              status: response.status,
              error: this.errorService.getErrorMessage(response)
            };
            return of(fromRideAction.getBustStopsFailed({ data: error }));
          })
        )
      )
    )
  );

  getBusStopsSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRideAction.getBustStopsSuccess),
        tap((action) => {
          console.log('getBusStopsSuccess$', action.data);
        })
      ),
    { dispatch: false }
  );

  getBusActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromRideAction.getBusActivity),
      exhaustMap((action) =>
        this.rideService.getBusActivity(action.data).pipe(
          map((response) => {
            this.store.dispatch(setLoadingSpinner({ status: false }));
            console.log(action?.routeInfo);
            const navigationExtras: NavigationExtras = {
              queryParams: {
                routeInfo: action?.routeInfo,
              },
              replaceUrl: false
            }
            this.navCtrl.navigateForward('/home/ride/bus-activity', navigationExtras);
            return fromRideAction.getBusActivitySuccess({ data: response?.details, busInfo: action?.busInfo, routeCoordinates: action?.data?.routeCoordinates });
          }),
          catchError((response) => {
            console.error('getBusActivity$', response);
            this.store.dispatch(setLoadingSpinner({ status: false }));
            const error = {
              status: response.status,
              error: this.errorService.getErrorMessage(response)
            };
            return of(failedTransaction({ data: error }));
          })
        )
      )
    )
  );

  getBusActivitySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRideAction.getBusActivitySuccess),
        tap((action) => {
          console.log('getBusActivitySuccess$', action);
        })
      ),
    { dispatch: false }
  );

  getBusActivityFailed$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRideAction.getBustStopsFailed),
        tap((action) => {
          console.log('getBusActivityFailed$', action.data);
          this.store.dispatch(setLoadingSpinner({ status: false }));            
          window.dispatchEvent(new CustomEvent('account:changePassword', { detail: action.data?.error}));      
        })
      ),
    { dispatch: false }
  );

  getRideHistory$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ROUTER_NAVIGATION),
      filter((r : RouterNavigatedAction) => {
        return r.payload.routerState.url.startsWith('/home/bottom-tabs/transaction-history')
      }),
      mergeMap(() => {
        return this.rideService.getRideHistory().pipe(
          map((response: APIResponse) => {           
            console.log('getRideHistory$', response);
            return fromRideAction.getRideHistorySuccess({ data: response.details});
          })
        );
      })
    )
  });
    
  async presentToast(msg, pos, style) {
      const toast = await this.toastController.create({
      message: msg,
      duration: 3000,
      position: pos,
      cssClass: style
      });
      toast.present();
  }

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private errorService: ErrorService,
    private rideService: RideService,
    private toastController: ToastController,
    private navCtrl: NavController,
    private modalController: ModalController
  ) {}
}

